<template>
    <div>
        <div class="card-body reporting-db-section">
            <div class="d-flex no-block">
                <h2 class="card-title mb-0"
                    style="font-weight: 700 !important; font-size: 2.2em !important">Ticket Risks Cases <span
                    style="color:#ccc; font-size: 12px">(Top 20)</span></h2>
            </div>
            <h6 class="card-subtitle mb-0" >This table lists all tickets that has been unresolved longer than what should normally be required for the priority.</h6>
            <h6 class="font-weight-bolder" style="font-size: 12px; margin-left: 1px">
                <span style="color: #55CE63;">Low : {{settings.risk_days_low_priority}} Days</span> &middot; <span style="color: #409EFF;">Medium : {{settings.risk_days_medium_priority}} Days</span> &middot; <span style="color: #F62D51;">High : {{settings.risk_days_high_priority}} Days</span></h6>
        </div>
        <div class="table-responsive">
            <table class="table table-hover no-wrap ticket-risks-table">
                <thead>
                <tr>
                    <th colspan="1" class="text-left" style="min-width: 120px">REF</th>
                    <th colspan="3" style="min-width: 200px">PROPERTY</th>
                    <th colspan="4">DESCRIPTION</th>
                    <th colspan="2" style="min-width: 180px">ASSIGNED TO</th>
                    <th colspan="1" class="text-center">DAYS OPEN</th>
                </tr>
                </thead>

                <tbody v-for="(tickets, priority) in ticketPrioritySets">
                <tr :class="'th-'+priority.toLowerCase()+'-priority-row'" style="padding-top:20px">
                    <td colspan="12" style="padding-top:30px !important;"><span
                        style="font-size: 13px; font-weight: 500;">{{priority}} priority tickets ({{getLimitValue(priority)}} day limit)</span>
                    </td>
                </tr>
                <tr v-for="ticket in tickets" @click.prevent="openTicket(ticket.id)" style="cursor: pointer">
                    <td colspan="1" class="text-left font-weight-bold">
                        <a href="#" target="_blank" class="ticket-link">{{ticket.ticket_reference_number}}</a>
                    </td>
                    <td colspan="3" class="txt-oflo">{{ticket.property}}</td>
                    <td colspan="4" class="txt-oflo">{{ticket.description}}</td>
                    <td colspan="2">{{ticket.assigned_to_name}}</td>
                    <td colspan="1" class="text-center">{{ticket.days}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ticket-risk-cases",

        props: ["settings"],

        data () {
            return {
                ticketPrioritySets: null,
            };
        },

        created () {
            this.fetchRiskTickets();
        },

        methods: {
            getLimitValue (priority) {
                switch (priority) {
                    case "Low" :
                        return this.settings.risk_days_low_priority;
                    case "Medium" :
                        return this.settings.risk_days_medium_priority;
                    case "High" :
                        return this.settings.risk_days_high_priority;
                    default:
                        return 0;
                }
            },

            fetchRiskTickets () {
                axios.get("/reporting-dashboard/ticket-risk-cases/all", new AppForm({}))
                .then((response) => {
                    this.ticketPrioritySets = response.data;
                }).catch(() => {
                    toastr.error("Could not fetch risk tickets!");
                });
            },

            openTicket (id) {
                window.open("/tickets/" + id, "_blank");
            }
        }

    };
</script>

<style scoped>
    .th-low-priority-row {
        color: #55CE63;
        border-bottom: 2px solid #55CE63;
    }

    .th-medium-priority-row {
        color: #409EFF;
        border-bottom: 2px solid #409EFF;
    }

    .th-high-priority-row {
        color: #F62D51;
        border-bottom: 2px solid #F62D51;
    }

    .ticket-link {
        text-decoration: none;
        color: inherit;

    }

    .ticket-risks-table tr {
        white-space: normal;
    }

    .ticket-risks-table tr td {
        white-space: inherit;
    }
</style>
